import { observable, action } from "mobx";
import ga from "util/gaEventTracker";
import history from "util/history";
import forEach from "lodash/forEach";
import isUndefined from "lodash/isUndefined";
import autobind from "autobind-decorator";

class TabbedSectionModel {
    @observable activeTab;
    anchorMap = {};
    replaceState = true;
    showArrows = false;
    maxTab = 0;
    isCollapsible = false;

    constructor(activeTab, showArrows, isCollapsible) {
        this.activeTab = isUndefined(activeTab) ? 1 : activeTab;
        this.showArrows = showArrows || false;
        this.isCollapsible = isCollapsible || false;
    }

    @autobind
    @action
    changeTab(tabIndex, shouldPopState, url) {
        if (this.isCollapsible && tabIndex === this.activeTab) {
            // Hide the current tab
            tabIndex = 0;
            url = null;
        }
        // save next tab to history unless we are completing a popstate event
        if (!shouldPopState && this.replaceState) {
            history.pushState({ activeTab: tabIndex }, "", url);
        }

        this.activeTab = tabIndex;

        ga("tab", "changeTab", "changeTab" + tabIndex);
    }

    @autobind
    @action
    nextTab() {
        if (this.activeTab < this.maxTab) {
            this.changeTab(this.activeTab + 1);
        }
    }

    @autobind
    @action
    previousTab() {
        if (this.activeTab > 1) {
            this.changeTab(this.activeTab - 1);
        }
    }

    @autobind
    updateAnchorMap(tabs) {
        forEach(tabs, tab => {
            if (tab.props.anchor && !tab.props.hidden) {
                this.anchorMap["#" + tab.props.anchor] = tab.props.index;
            }
        });
        this.maxTab = tabs.length;
    }

    @autobind
    updateHistory() {
        history.replaceState({ activeTab: this.activeTab }, "");
        history.addPopStateListener((e) => {
            if (e.state) {
                this.changeTab(e.state.activeTab, true);
            }
        });

        if (typeof window !== "undefined" && this.anchorMap) {
            if (this.anchorMap[window.location.hash]) {
                this.changeTab(this.anchorMap[window.location.hash], false);
            }
        }
    }
}

export default TabbedSectionModel;
